// extracted by mini-css-extract-plugin
export var RecruitCulture = "RecruitCulture-module--RecruitCulture--15z9S";
export var RecruitCulture__inner = "RecruitCulture-module--RecruitCulture__inner--ETQXL";
export var RecruitCulture__content = "RecruitCulture-module--RecruitCulture__content--5ZjOQ";
export var RecruitCulture__num = "RecruitCulture-module--RecruitCulture__num--1aCUU";
export var RecruitCulture__img = "RecruitCulture-module--RecruitCulture__img--16bRn";
export var RecruitCulture__title = "RecruitCulture-module--RecruitCulture__title--1mJkY";
export var RecruitCulture__text = "RecruitCulture-module--RecruitCulture__text--2JdDm";